import { Mixpanel } from "@/lib/mixpanel";
import { Export } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import SelectingBoatButton from "../../components/select-vessel-button";

const Header = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="relative flex w-full flex-row items-center justify-between px-5">
      <SelectingBoatButton />
      <h1 className="absolute left-1/2 -translate-x-1/2 text-[15px] font-semibold leading-7 text-white">
        {t("title.reports").toLocaleUpperCase(i18n.language)}
      </h1>
      <button
        onClick={() => {
          Mixpanel.track("Export Reports");
        }}
      >
        <Export color="white" size={20} />
      </button>
    </div>
  );
};

export default Header;
